import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'ui-components/default-props/noop';
import { MarketplaceSettings } from '@shipstation/connections-ui';
import { DirectMarketplaceSettings } from '@shipstation/connections-ui/direct';
import { useCommonCuiProps } from './helpers/use-common-cui-props';
import { useCuiApiConfig } from './helpers/use-cui-api-config';
import { useCuiContextProps } from './helpers/use-cui-context-props';
import { useEnableRemoveIframeMarketplace } from '../feature-flags/hooks/use-enable-remove-iframe-marketplace';

export const SSMarketplaceSettings = ({ onError = noop, onCancel = noop, onSave = noop, storeGuid, marketplaceApiCode }) => {
  const isDirectMode = useEnableRemoveIframeMarketplace();
  const commonCuiProps = useCommonCuiProps();
  const cuiApiConfig = useCuiApiConfig();
  const cuiContextProps = useCuiContextProps();

  const directContextProps = useMemo(
    () => ({ ...cuiContextProps, onCancel, onError, onSave }),
    [cuiContextProps, onCancel, onError, onSave],
  );

  if (isDirectMode) {
    return (
      <DirectMarketplaceSettings
        apiConfig={cuiApiConfig}
        contextProps={directContextProps}
        marketplaceApiCode={marketplaceApiCode}
        storeGuid={storeGuid}
      />
    );
  }

  return (
    <MarketplaceSettings
      {...commonCuiProps}
      marketplaceApiCode={marketplaceApiCode}
      onCancel={onCancel}
      onError={onError}
      onSave={onSave}
      storeGuid={storeGuid}
    />
  );
};

SSMarketplaceSettings.propTypes = {
  onError: PropTypes.func,
  onCancel: PropTypes.func,
  onSave: PropTypes.func,
  storeGuid: PropTypes.string,
  marketplaceApiCode: PropTypes.string,
};
